import angular, { ILogService, IOnChangesObject } from 'angular'
import { IEstadoCvStore } from 'src/model/candidato-api'

class CvStateComponentCtrl {
  estados!: IEstadoCvStore
  state!: string
  simple!: boolean

  _stateDesc: string

  constructor(private $log: ILogService) {}

  $onInit(): void {
    this.$log.info('[CvStateComponentCtrl] onInit')
  }

  $onChanges(changes: IOnChangesObject) {
    this.$log.info('----> changes', changes)

    if (changes.state || changes.tipos) {
      this._stateDesc = this._estadoDesc()
    }
  }

  private _estadoDesc() {
    let t = this.estados && this.estados.data[this.state]

    return (t && `${t.estado.texto_en} - ${t.estado.texto_es}`) || this.state
  }

  get stateDesc() {
    this.$log.info('[stateDesc]')
    return this._stateDesc
  }
}

angular.module('candidato').component('cvState', {
  bindings: {
    estados: '<',
    state: '<',
    simple: '<',
  },
  controller: CvStateComponentCtrl,
  // templateUrl: "cv-state.component.html",
  template: require('./cv-state.component.html'),
})
